import { Accordion, AccordionDetails, AccordionSummary, Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { StyledTableCell, StyledTableRow } from '../../../../components/Table.styled';
import CompliancePlip from '../../../../components/CompliancePlip';
import { TeamMemberFilterOption, TrainingSummary } from '../types';

interface Props {
  defaultTeamMemberFilter: TeamMemberFilterOption;
  selectedTeamMember: TeamMemberFilterOption;
  trainingSummary: TrainingSummary[];
}

const TrainingSummaryComponent: React.FC<Props> = ({ defaultTeamMemberFilter, selectedTeamMember, trainingSummary }) => {
  return (
    <Box className="m-t-16">
      <Accordion disableGutters sx={{ mb: 1 }} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div className="header-text">Training Summary</div>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell>User</StyledTableCell>
                <StyledTableCell>Overdue</StyledTableCell>
                <StyledTableCell>Not Started</StyledTableCell>
                <StyledTableCell>In Progress</StyledTableCell>
                <StyledTableCell>Completed</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {trainingSummary
                .filter((user) => selectedTeamMember.name === defaultTeamMemberFilter.name || user.userName === selectedTeamMember.name)
                .sort((a: any, b: any) => {
                  if (a.userName.toLowerCase() < b.userName.toLowerCase()) return -1;
                  if (a.userName.toLowerCase() > b.userName.toLowerCase()) return 1;
                  return 0;
                })
                .map((user: any) => (
                  <StyledTableRow key={user.userId}>
                    <StyledTableCell>
                      <CompliancePlip className="m-r-8" status={user.complianceStatus} />
                    </StyledTableCell>
                    <StyledTableCell>{user.userName}</StyledTableCell>
                    <StyledTableCell>{user.overdue}</StyledTableCell>
                    <StyledTableCell>{user.notStarted}</StyledTableCell>
                    <StyledTableCell>{user.inProgress}</StyledTableCell>
                    <StyledTableCell>{user.completed}</StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default TrainingSummaryComponent;
